import { useTranslation } from "react-i18next";
import OrbButton from "../orb-button";
import { btnConfig } from "./orb-confirmatiion-config";
import { confirmationProps } from "./orb-confirmation-interface";
import styleSheet from "./style.module.scss";
const OrbConfirmation = (props: confirmationProps) => {
  const { message, onConfirmClick, buttons= btnConfig} = props;
 const { t } = useTranslation();
  const onHandleClick = (val: any) => {
    onConfirmClick(val);
  };

  return (
    <>
      <div className={`${styleSheet.main} p-4`}>
        <p>{t(message)}</p>
        <div className={` mt-3 gap-2 d-flex justify-content-end `}>
          {buttons?.map((btn: any) => {
            return (
              <OrbButton
                type={"submit"}
                className={" mohave "}
                size={""}
                value={btn.value}
                onBtnClick={onHandleClick}
                label={t(btn.label)}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default OrbConfirmation;
